import React from 'react'
import MasterLayout from 'views/MasterLayout'
import PurchasingRouter from './Router'

export default function ClientsLayout(props) {
  return (
    <MasterLayout>
      <PurchasingRouter match={props.match}/>
    </MasterLayout>
  )
}
